import PantallaGameGenerator from './pantalla-game-generator'
export default PantallaGameGenerator